export default function(map) {
    let result = [];
    for (let i of map) {
        result.push(i[0]);
    }
    return result;
}
